"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// packages/react/radix-ui/src/index.ts
var src_exports = {};
__export(src_exports, {
  AccessibleIcon: () => AccessibleIcon,
  Accordion: () => Accordion,
  AlertDialog: () => AlertDialog,
  AspectRatio: () => AspectRatio,
  Avatar: () => Avatar,
  Checkbox: () => Checkbox,
  Collapsible: () => Collapsible,
  ContextMenu: () => ContextMenu,
  Dialog: () => Dialog,
  Direction: () => Direction,
  DropdownMenu: () => DropdownMenu,
  Form: () => Form,
  HoverCard: () => HoverCard,
  Label: () => Label,
  Menubar: () => Menubar,
  NavigationMenu: () => NavigationMenu,
  Popover: () => Popover,
  Portal: () => Portal,
  Progress: () => Progress,
  RadioGroup: () => RadioGroup,
  ScrollArea: () => ScrollArea,
  Select: () => Select,
  Separator: () => Separator,
  Slider: () => Slider,
  Slot: () => Slot,
  Switch: () => Switch,
  Tabs: () => Tabs,
  Toast: () => Toast,
  Toggle: () => Toggle,
  ToggleGroup: () => ToggleGroup,
  Toolbar: () => Toolbar,
  Tooltip: () => Tooltip,
  VisuallyHidden: () => VisuallyHidden
});
module.exports = __toCommonJS(src_exports);
var AccessibleIcon = __toESM(require("@radix-ui/react-accessible-icon"));
var Accordion = __toESM(require("@radix-ui/react-accordion"));
var AlertDialog = __toESM(require("@radix-ui/react-alert-dialog"));
var AspectRatio = __toESM(require("@radix-ui/react-aspect-ratio"));
var Avatar = __toESM(require("@radix-ui/react-avatar"));
var Checkbox = __toESM(require("@radix-ui/react-checkbox"));
var Collapsible = __toESM(require("@radix-ui/react-collapsible"));
var ContextMenu = __toESM(require("@radix-ui/react-context-menu"));
var Dialog = __toESM(require("@radix-ui/react-dialog"));
var Direction = __toESM(require("@radix-ui/react-direction"));
var DropdownMenu = __toESM(require("@radix-ui/react-dropdown-menu"));
var Form = __toESM(require("@radix-ui/react-form"));
var HoverCard = __toESM(require("@radix-ui/react-hover-card"));
var Label = __toESM(require("@radix-ui/react-label"));
var Menubar = __toESM(require("@radix-ui/react-menubar"));
var NavigationMenu = __toESM(require("@radix-ui/react-navigation-menu"));
var Popover = __toESM(require("@radix-ui/react-popover"));
var Portal = __toESM(require("@radix-ui/react-portal"));
var Progress = __toESM(require("@radix-ui/react-progress"));
var RadioGroup = __toESM(require("@radix-ui/react-radio-group"));
var ScrollArea = __toESM(require("@radix-ui/react-scroll-area"));
var Select = __toESM(require("@radix-ui/react-select"));
var Separator = __toESM(require("@radix-ui/react-separator"));
var Slider = __toESM(require("@radix-ui/react-slider"));
var Slot = __toESM(require("@radix-ui/react-slot"));
var Switch = __toESM(require("@radix-ui/react-switch"));
var Tabs = __toESM(require("@radix-ui/react-tabs"));
var Toast = __toESM(require("@radix-ui/react-toast"));
var Toggle = __toESM(require("@radix-ui/react-toggle"));
var ToggleGroup = __toESM(require("@radix-ui/react-toggle-group"));
var Toolbar = __toESM(require("@radix-ui/react-toolbar"));
var Tooltip = __toESM(require("@radix-ui/react-tooltip"));
var VisuallyHidden = __toESM(require("@radix-ui/react-visually-hidden"));
//# sourceMappingURL=index.js.map
